import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useField } from '@unform/core';

type TAutoCompleteOption = {
    option: string;
}

interface IAutoCompleteIsFullStationProps {
    isExternalLoading?: boolean;
}

export const AutoCompleteIsFullStation: React.FC<IAutoCompleteIsFullStationProps> = ({ isExternalLoading = false }) => {

    const { fieldName, registerField, defaultValue, error, clearError } = useField('fullStation');
    const [selectedIsFullStation, setSelectedIsFullStation] = useState<string | undefined>(defaultValue);
    const [isLoading, setIsLoading] = useState(true);
    const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
    const [busca, setBusca] = useState('');

    useEffect(() => {
        registerField({
            name: fieldName,
            getValue: () => selectedIsFullStation,
            setValue: (_, newSelectedIsFullStation) => setSelectedIsFullStation(newSelectedIsFullStation),
        });
    }, [registerField, fieldName, selectedIsFullStation]);

    useEffect(() => {
        setIsLoading(false)
        setOpcoes([
            { option: "SIM" },
            { option: "NÃO" }
        ])
    }, [busca]);

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIsFullStation) return null;

        const selectedOption = opcoes.find(opcao => opcao.option === selectedIsFullStation);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIsFullStation, opcoes]);


    return (
        <Autocomplete
            openText='Abrir'
            closeText='Fechar'
            noOptionsText='Sem opções'
            loadingText='Carregando...'
            clearText='Limpar'

            disablePortal

            options={opcoes}
            getOptionLabel={(option) => option.option ?? option}
            loading={isLoading}
            disabled={isExternalLoading}
            value={autoCompleteSelectedOption}
            onInputChange={(_, newValue) => setBusca(newValue)}
            onChange={(_, newValue) => { setSelectedIsFullStation(newValue?.option); setBusca(''); clearError(); }}
            popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
            renderInput={(params) => (
                <TextField
                    {...params}

                    label="Posto?"
                    error={!!error}
                    helperText={error}
                />
            )}
        />
    );
};